module.exports = __webpack_public_path__ + "static/media/ctwa.47ec08cd.png";